const SectionHeader = ({ eyebrow, title, description, align = "left", testId }) => {
  const alignmentClass = align === "center" ? "max-w-3xl" : "max-w-2xl";

  return (
    <div className={`space-y-5 ${alignmentClass}`} data-testid={testId}>
      <p className="eyebrow" data-testid={`${testId}-eyebrow`}>
        {eyebrow}
      </p>
      <div className="space-y-4">
        <h2 className="text-4xl font-black tracking-[-0.05em] text-[#0A0A0A] sm:text-5xl" data-testid={`${testId}-title`}>
          {title}
        </h2>
        <p className="max-w-xl text-sm leading-7 text-[#52525B] sm:text-base" data-testid={`${testId}-description`}>
          {description}
        </p>
      </div>
    </div>
  );
};

export default SectionHeader;